import React from 'react';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import { getSelectOptions } from 'src/reducers/selectOptions';
import selector, { employeeDisplay } from 'src/utils/Utils';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const BasicInfoSectionShow = ({ employee, prefectures, titles }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.name')}</th>
            <td>{employeeDisplay.fullName(employee, i18n)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.FamilySupportsSectionShow.Birthdate')}</th>
            <td>{employeeDisplay.birthday(employee)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.Address')}</th>
            <td>{employeeDisplay(employee.fullAddress)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.Phone_number')}</th>
            <td>{employeeDisplay(employee.tel)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.email')}</th>
            <td>{employeeDisplay(employee.email)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.Personal_id')}</th>
            <td>{employeeDisplay(employee.personalNumber)}</td>
          </tr>
          <tr>
            <th>{t('features.Employees.components.BasicInfoSectionShow.nationality')}</th>
            <td>{employeeDisplay(employee.nationality)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default connect(state => ({
  employee: selector(getItem(REDUCER_NAME, state), 'employee'),
  prefectures: getSelectOptions(state, 'prefectures'),
  titles: getSelectOptions(state, 'titles')
}))(BasicInfoSectionShow);
